import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext'
import { KEY_DOWN_COMMAND } from 'lexical'
import { FC, useEffect } from 'react'

type SubmitOnEnterPluginProps = {
  onEnter?: () => void
  disabled?: boolean
}

const SubmitOnEnterPlugin: FC<SubmitOnEnterPluginProps> = ({ onEnter, disabled = false }) => {
  const [editor] = useLexicalComposerContext()

  useEffect(() => {
    const removeListener = editor.registerCommand(
      KEY_DOWN_COMMAND,
      (event: KeyboardEvent) => {
        // NOTE: Allowing shift+enter for multi-line
        if (event.key === 'Enter' && !event.shiftKey) {
          if (!disabled) {
            event.preventDefault()
            onEnter?.()
            return true
          }
        }
        return false
      },
      0,
    )

    return () => {
      removeListener()
    }
  }, [editor, onEnter, disabled])

  return null
}

export default SubmitOnEnterPlugin
